import React from 'react';
import $ from 'jquery';

function MobilePhoneNumber({ article }) {
  function goToForm(e) {
    e.preventDefault();
    e.stopPropagation();
    if ($('#tukur-form').length) {
      // smooth scroll to the form
      $('body, html').animate({ scrollTop: $('#tukur-form').offset().top }, 500);
    }
  }

  return (
    <div className="hidden-desktop" style={{ backgroundColor: '#eaf1f6' }}>
      <div className="container">
        <div className="row">
          <aside className="sidebar">&nbsp;</aside>
          <article className="content margin-top-xs margin-bottom-xs">
            <h6 className="text-uppercase text-center no-margin" onClick={goToForm}>
              <small className="color-text">
                {article.landingpage.vCheck
                  ? 'Vermögen checken. Rendite sichern:'
                  : 'Alle Antworten im Quirin Buch:'}
                &nbsp;
                <a href="#">
                  {article.landingpage.vCheck
                    ? 'Kostenlos checken'
                    : 'Kostenlos anfordern. Rendite sichern.'}
                </a>
              </small>
            </h6>
          </article>
          <aside className="spacebar">&nbsp;</aside>
        </div>
      </div>
    </div>
  );
}

MobilePhoneNumber.propTypes = {
  article: React.PropTypes.object
};

export default MobilePhoneNumber;



// WEBPACK FOOTER //
// ./components/landingpage/mobileAnchor.js